import { render } from "./oti_show.vue?vue&type=template&id=5f174d62&scoped=true"
import script from "./oti_show.vue?vue&type=script&lang=js"
export * from "./oti_show.vue?vue&type=script&lang=js"

import "./oti_show.vue?vue&type=style&index=0&id=5f174d62&scoped=true&lang=css"
import "./oti_show.vue?vue&type=style&index=1&id=5f174d62&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f174d62"]])

export default __exports__